import React from 'react'
import { Link } from 'react-router-dom'

import img503 from "../../assets/images/503.svg"

const Error503 = () => {
  return (
    <React.Fragment>
      <section className="min-h-[calc(100vh-134px)] flex items-center justify-center">
        <div className="max-w-[1440px] mx-auto text-center px-4">
          <div className="mt-10 space-y-4">
            <h2 className="text-3xl font-bold md:text-5xl dark:text-white">503 Not Found</h2>
            <p className="text-base text-muted dark:text-darkmuted">Sorry, we can’t find that page.</p>
            <img src={img503} className="mx-auto sm:max-w-xs" alt="" />
            <div>
              <Link to="/index" className="inline-block btn text-purple border-purple hover:bg-purple hover:text-white">
                Back To Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default Error503
